import { AggregationFunction } from "@multiweb/clients/dataReader";
import { AVG_OPTION_LOC_KEY, MAX_OPTION_LOC_KEY, MIN_OPTION_LOC_KEY, SUM_OPTION_LOC_KEY } from "./locKeys";
import { AggregationFunctionLocalizableOption } from "./types";

const SUM_OPTION: AggregationFunctionLocalizableOption = {
    locKey: SUM_OPTION_LOC_KEY,
    value: AggregationFunction.sum,
};

const AVG_OPTION: AggregationFunctionLocalizableOption = {
    locKey: AVG_OPTION_LOC_KEY,
    value: AggregationFunction.avg,
};

const MIN_OPTION: AggregationFunctionLocalizableOption = {
    locKey: MIN_OPTION_LOC_KEY,
    value: AggregationFunction.min,
};

const MAX_OPTION: AggregationFunctionLocalizableOption = {
    locKey: MAX_OPTION_LOC_KEY,
    value: AggregationFunction.max,
};

/**
 * Dostupné možnosti pro výběr agregační funkce. Pořadí odpovídá sketchy ze zadání user story 1560.
 */
export const AGGREGATION_OPTIONS: ReadonlyArray<AggregationFunctionLocalizableOption> = [SUM_OPTION, AVG_OPTION, MIN_OPTION, MAX_OPTION];

/**
 * Lokalizační klíče možností pro výběr agregační funkce.
 */
export const OPTIONS_LOCALIZATION_KEYS: ReadonlyArray<string> = AGGREGATION_OPTIONS.map((option) => option.locKey);
